import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@catalogo/theme-layout';
import CreditCardIcon from '@catalogo/ui-americanas-desktop-svg/credit-card-b.svg';

const Text = styled.p`
  color: ${({ theme }) => theme.grey.dark};
  line-height: 18px;
  font-size: 14px;
  font-weight: 400;
  margin-top: 2px;
`;

const Container = styled(Flex)`
  gap: 4px;
  margin-top: 10px;
`;

const CardIcon = ({ text }) => <CreditCardIcon fill="#666" width={20} height={20} />;

export const PaymentInstallmentText = ({ text }) => (
  <Container>
    <Box>
      <CardIcon text={text} />
    </Box>
    <Box fluid>
      <Text>{text}</Text>
    </Box>
  </Container>
);
